<template>
  <section id="expired-link">
    <img
      class="nothing-going-on"
      src="@shared/assets/img/general/svg/invite-expired.svg"
    >
  </section>
</template>

<script>
export default {
  name: 'ExpiredLinkView',
  metaInfo: {
    title: 'SmartAC.com | Expired Link',
  },
};
</script>

<style lang="scss">
section#expired-link {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;

  .nothing-going-on {
    height: 90vh;
  }
}
</style>
